import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UiRouterState } from '../../services/ajs-router-state.service';
import { StateParamsService } from '../../services/ajs-state-params.service';
import { ChartsService } from '../../services/charts.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../services/ajs-auth.service';
import { ClienteResource } from '../../services/ajs-cliente-resource.service';
import { TourService } from '../../tour/tour.service';

declare var google: any;

const INIT_DATE = '2017-04-01';

export interface IDateSelect {
  label: string;
  value: string;
}

function totalValues(values) {
  return _.reduce(values, (result, value) => result + value, 0);
}

function getPercentage(value: number, total: number, digits = 2) {
  if (+value === 0 || +total === 0) {
    return '0';
  }

  return ((value / total) * 100).toFixed(digits);
}

@Component({
  selector: 'mandae-indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IndicatorsComponent implements OnInit, AfterViewInit {
  bars = {
    onDate: { label: 'Entregues dentro do prazo', value: '' },
    overdue: { label: 'Entregues com atraso', value: '' },
    waiting: { label: 'Aguardando entrega', value: '' },
    other: { label: 'Outros', value: '' },
    made: { label: 'Entregas realizadas', value: '' },
  };
  isLoading = false;
  shipments: any;
  deliveries: any;
  totalShipments: any;
  dataHoraCriacao: any;
  deliveriesPercent: string;
  months: IDateSelect[] = [];
  selectedDate: string = null;

  constructor(
    private charts: ChartsService,
    private auth: AuthService,
    private cliente: ClienteResource,
    private tour: TourService,
    private state: UiRouterState,
    private stateParams: StateParamsService,
  ) { }

  async ngOnInit() {
    try {
      const profile = await this.cliente.getProfile({ idCliente: this.auth.getCurrentUser().id }).$promise;

      this.dataHoraCriacao = profile.dataHoraCriacao;
      this.mountCharts();
    } catch (e) {
      console.log('Error API clientes', e);
    }
  }

  ngAfterViewInit() {
    if (this.stateParams.tour) {
      this.startTour();
    }
  }

  onDateChange(newValue) {
    this.selectedDate = newValue;
    this.getCharts();
  }

  monthValue(index: number, item: IDateSelect) {
    return item.value;
  }

  private setCallbacks() {
    google.charts.load('current', {'packages': ['corechart', 'bar']});
    google.charts.setOnLoadCallback(() => this.enviosChart());
    google.charts.setOnLoadCallback(() => this.dentroDoPrazoChart());
    google.charts.setOnLoadCallback(() => this.foraDoPrazoChart());
  }

  private enviosChart() {
    const data = google.visualization.arrayToDataTable([
      ['', '', {role: 'style'}, {role: 'annotation'}],
      ['', this.shipments.outros, '#ffdd00', this.shipments.outros + ' (' + this.bars.other.value + '%)'],
      ['', this.shipments.aguardandoEntrega, '#ff6900', this.shipments.aguardandoEntrega + ' (' + this.bars.waiting.value + '%)'],
      ['', this.deliveries, '#4a90e2', this.deliveries + ' (' + this.bars.made.value + '%)'],
      ['', this.totalShipments, '#9013fe', this.totalShipments]
    ]);

    const options = {
      chartArea: {
        width: '90%',
        left: 10,
      },
      backgroundColor: '#4a4a4a',
      bar: { groupWidth: '95%' },
      legend: { position: 'none' },
      annotations: {
        textStyle: {
          color: 'white',
        }
      },
      hAxis: {
        minValue: 0,
        baselineColor: 'white',
        textStyle: {
          color: 'white',
        },
        gridlines: {
          color: 'white',
          count: -1,
        }
      },
    };

    const chart = new google.visualization.BarChart(document.getElementById('envios'));
    chart.draw(data, options);
  }

  private dentroDoPrazoChart() {
    const data = google.visualization.arrayToDataTable([
      ['', '', {role: 'style'}, {role: 'annotation'}],
      ['', this.shipments.entregueDentroPrazo, '#7ed321', this.shipments.entregueDentroPrazo + ' (' + this.bars.onDate.value + '%)'],
      ['', this.deliveries, '#4a90e2', this.deliveries]
    ]);

    const options = {
      height: 100,
      chartArea: {
        width: '90%',
        height: '50',
        top: 10,
        left: 3,
      },
      bar: { groupWidth: '95%' },
      legend: { position: 'none' },
      hAxis: {
        minValue: 0,
        gridlines: {
          count: -1,
        }
      },
    };

    const chart = new google.visualization.BarChart(document.getElementById('dentroDoPrazo'));
    chart.draw(data, options);
  }

  private foraDoPrazoChart() {
    const data = google.visualization.arrayToDataTable([
      ['', '', {role: 'style'}, {role: 'annotation'}],
      ['', this.shipments.entregueComAtraso, '#d0021b', this.shipments.entregueComAtraso + ' (' + this.bars.overdue.value + '%)'],
      ['', this.deliveries, '#4a90e2', this.deliveries]
    ]);

    const options = {
      height: 100,
      chartArea: {
        width: '90%',
        height: '50',
        top: 10,
        left: 3,
      },
      bar: { groupWidth: '95%' },
      legend: { position: 'none' },
      hAxis: {
        minValue: 0,
        gridlines: {
          count: -1,
        },
      },
    };

    const chart = new google.visualization.BarChart(document.getElementById('foraDoPrazo'));
    chart.draw(data, options);
  }

  private setDeliveries(shipments, totalShipments) {
    const deliveryValues = _.pick(shipments, ['entregueDentroPrazo', 'entregueComAtraso']);
    this.deliveries = totalValues(deliveryValues);
    this.deliveriesPercent = getPercentage(this.deliveries, totalShipments);
  }

  private setBarValues(totalDeliveries) {
    this.bars['onDate'].value  = getPercentage(this.shipments.entregueDentroPrazo, totalDeliveries);
    this.bars['overdue'].value = getPercentage(this.shipments.entregueComAtraso, totalDeliveries);
  }

  private setBarMainValues(totalShipments) {
    this.bars['other'].value = getPercentage(this.shipments.outros, totalShipments);
    this.bars['waiting'].value = getPercentage(this.shipments.aguardandoEntrega, totalShipments);
    this.bars['made'].value = getPercentage(this.deliveries, totalShipments);
  }

  private mountCharts() {
    this.months = this.mountSelect(this.dataHoraCriacao);
    this.getCharts();
  }

  private mountSelect(startDate) {
    const nowNormalized = moment().startOf('month'),
      initDate = moment(startDate).isBefore(INIT_DATE) ? INIT_DATE : startDate,
      startDateNormalized = moment(initDate).clone().startOf('month'),
      months: IDateSelect[] = [];
    while (startDateNormalized.isBefore(nowNormalized)) {
      months.push({
        label: startDateNormalized.format('MMMM/YYYY'),
        value: startDateNormalized.toISOString(),
      });
      startDateNormalized.add(1, 'M');
    }
    months.push({
      label: nowNormalized.format('MMMM/YYYY'),
      value: nowNormalized.toISOString(),
    });
    this.selectedDate = months[months.length - 1].value;

    return months;
  }

  private getCharts() {
    setTimeout(() => {
      this.isLoading = true;
      this.charts.get(this.auth.getCurrentUser().id, { data: this.selectedDate })
      .pipe(
        tap(response => {
          this.shipments = response.envios;
          const shipmentsValues = _.omit(this.shipments, ['clienteId', 'periodo']);
          this.totalShipments = totalValues(shipmentsValues);
          this.setDeliveries(this.shipments, this.totalShipments);
          this.setBarValues(this.deliveries);
          this.setBarMainValues(this.totalShipments);
          this.setCallbacks();
        }),
        catchError((err: HttpErrorResponse) => of({ status: err.statusText })),
        tap(() => this.isLoading = false),
      )
      .subscribe();
    });
  }

  private startTour() {
    const steps = this.tour.makeTour([
      {
        title: 'Controle seus números',
        text: 'Tenha uma visão resumida de suas entregas do mês, sabendo facilmente o que está dentro e fora do prazo de entrega.',
        attachTarget: () => document.querySelector<HTMLElement>('.menu-container a[href*="/indicadores"]'),
        next: {
          action: (e, ref) => {
            ref.close('to_next_section');
            this.state.go('financeiro', { tour: true });
          },
          text: 'Ir para Faturas',
        }
      },
    ]);

    this.tour.start(steps).subscribe();
  }
}
